import { WalkthroughVideoPlayer } from "@WahooFitness/redesignr";
import { Trans } from "@lingui/macro";
import { Box, Button } from "@mui/material";
import useGuidedVideo from "./useVideoPlayer";
import { useLingui } from "@lingui/react";

function VideoPlayer() {
  const { currentVideo, forwardNav, locale } = useGuidedVideo();
  const { i18n } = useLingui();

  if (!currentVideo) {
    return null;
  }

  return (
    // Fill the height left over by the navbar (flex: 1) instead of using height: 100%,
    // so the column never exceeds the viewport and the Next button stays pinned at the bottom.
    <Box flex={1} minHeight={0} width="100%" display="flex" flexDirection="column">
      <Box
        flex={1}
        minHeight={0}
        overflow="auto"
        display="flex"
        flexDirection="column"
        gap={4}
        alignItems="center"
      >
        <WalkthroughVideoPlayer
          videoUrl={currentVideo.url}
          steps={currentVideo.steps}
          i18nContext={i18n}
          incomingSelectedLanguage={locale}
        />
      </Box>
      <Box px={3} pt={2} pb="var(--wf-bottom-safe-area, 0px)" width="100%">
        <Button variant="contained" size="large" fullWidth onClick={forwardNav}>
          <Trans>Next</Trans>
        </Button>
      </Box>
    </Box>
  );
}

export default VideoPlayer;
